import { createVuestic } from 'vuestic-ui'
import config from './config'

export default createVuestic({ config })
